<template lang="">
  <!-- src/components/MyNavBar.vue -->
  <MyNavBar theme="light" />
  <!-- src/componts/MyHero.vue -->
  <MyHero :watchEnabled="true" />

  <body>
    <!-- <section id="filters">
      <section id="bodyFilters">
        <h2>Filtros de Pesquisa</h2>

        <p class="supportingText">
          Utilize estes filtros para refinar sua pesquisa.
        </p>

        <div class="grupsFilters" v-for="i in 3" :key="i">
          <h3>Linguagem {{ i }}</h3>
          <div class="checkboxFilters" v-for="i in 5" :key="i">
            <input type="checkbox" name="" id="lele" />
            <label for="">teste {{ i }}</label>
          </div>
        </div>
      </section>
    </section> -->

    <section id="results">
      <div id="resultsHeader">
        <h1>Resultado de Pesquisa</h1>
      </div>
      <!-- <div id="select">
        <select name="" id="" placeholder="Filtros">
          <option value="1"><p>Mais recentes</p></option>
          <option value="2"><p>Mais antigos</p></option>
          <option value="3"><p>Mais populares</p></option>
          <option value="4"><p>Menos populares</p></option>
        </select>
      </div> -->

      <!-- src/components/MyCard.vue -->
      <MyCard :oasAtributes="{ img: false }" />

      <div id="pagination">
        <button
          type="button"
          @click="
            {
              lessOffset();
            }
          "
        >
          <img src="../assets/icon-chevron-left.svg" alt="" />
        </button>
        <ul v-if="offsetNumber <= 4">
          <li v-for="i in 4" :key="i" @click="equalOffset(i)">{{ i }}</li>
        </ul>
        <ul v-else>
          <li
            v-for="i in getRange(offsetNumber - 2, offsetNumber - 1)"
            :key="i"
            @click="equalOffset(i)"
          >
            {{ i }}
          </li>
          <li style="font-weight: bold; text-decoration: underline">
            {{ offsetNumber }}
          </li>

          <li
            v-for="i in getRange(offsetNumber + 1, offsetNumber + 2)"
            :key="i"
            @click="equalOffset(i)"
          >
            {{ i }}
          </li>
        </ul>
        <button type="button" @click="plusOffset()">
          <img src="../assets/icon-chevron-right.svg" alt="" />
        </button>
      </div>
    </section>
  </body>
  <MyFooter />
</template>

<script>
import MyNavBar from "@/components/MyNavBar.vue";
import MyHero from "@/components/home/MyHero.vue";
import MyCard from "@/components/MyCard.vue";
import MyFooter from "@/components/MyFooter.vue";
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  props: ["searchQuery"],
  components: {
    MyNavBar,
    MyHero,
    MyCard,
    MyFooter,
  },
  data() {
    return {
      offsetNumber: 0,
    };
  },
  methods: {
    ...mapActions(["AgetOas", "setOffset", "setLimit"]),
    limitSearch() {
      this.$store.commit("setLimit", 15);
      this.$store.dispatch("AgetOas");
    },
    equalOffset(aux) {
      this.$store.commit("setOffset", aux);
      this.offsetNumber = aux;
      this.$store.dispatch("AgetOas");
    },
    plusOffset() {
      this.$store.commit("setOffset", (this.offsetNumber += 1));
      this.$store.dispatch("AgetOas");
    },
    lessOffset() {
      this.$store.commit("setOffset", (this.offsetNumber -= 1));
      this.$store.dispatch("AgetOas");
    },
    getRange(start, end) {
      return Array.from(
        { length: end - start + 1 },
        (_, index) => start + index
      );
    },
  },
  mounted() {
    if (this.searchQuery) {
      this.$store.commit("setSearch", this.searchQuery);
    }
    this.limitSearch();
  },
});
</script>

<style scoped lang="css">
* {
  color: var(--black);
}

body {
  /* display: grid;
  grid-template-columns: 30% 70%; */
}

#filters {
  height: auto;
  border-right: 1px solid var(--silver-medal, #d6d6d6);
  color: black;
}

#results {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

#results h1 {
  /* text-align: center; */
  font-weight: bold;
}

#filters h2,
#results h1 {
  color: var(--orange);
  /* text-align: center; */
}

#resultsHeader {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
}

.supportingText {
  color: var(--gray);
}

#results select,
option {
  display: flex;
  height: 54px;
  font-size: 18px;
  padding: 10px;
  border-radius: 4px;
  color: var(--orange, #d6d6d6);
  border: 1px solid var(--gray, #d6d6d6);
}

#bodyFilters {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 60px;
}

.grupsFilters {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.checkboxFilters {
  display: flex;
  align-items: center;
}

.checkboxFilters input {
  margin-right: 10px;
  height: 24px;
  width: 24px;
}

.checkboxFilters label {
  font-size: 22px;
}

#select {
  padding-left: 5%;
}

#pagination {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 15px;
}

#pagination ul,
li {
  color: var(--orange, #d6d6d6) !important;
  display: flex;
  text-decoration: none;
  cursor: pointer;
}

#pagination ul {
  gap: 20px;
}

#pagination button {
  text-decoration: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
</style>
